import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
  DataTable,
  Loading,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Select2 from "react-select";
const BookPastUpcoming = (props) => {
  const navigate = useNavigate();
  const { sessionId, classId } = useParams();
  const [optionsUsers, setOptionsUsers] = useState([]);
  const [optionsPackagesMemberships, setOptionsPackagesMemberships] = useState(
    [],
  );
  const [isSaving, setIsSaving] = useState(true);
  const [ts, setTs] = useState("");
  const [user, setUser] = useState("");
  const [classType, setClassType] = useState("");
  const handleChangeUser = (newValue) => {
    setUser(newValue);
    setUserError("");
  };
  const [userError, setUserError] = useState("");
  const [method, setMethod] = useState("");
  const [type, setType] = useState("");

  const [seats, setSeats] = useState([]);
  const [bankTransferAmount, setBankTransferAmount] = useState("");
  const [bankTransferAmountError, setBankTransferAmountError] = useState("");
  const handleChangeBankTransferAmount = (newValue) => {
    setBankTransferAmount(newValue);
    setBankTransferAmountError("");
  };
  const handleChangeMethod = (newValue) => {
    setMethod(newValue);
    setMethodError("");
    if (newValue !== "bank_transfer") {
      setBankTransferAmount("");
      setBankTransferAmountError("");
    }
  };
  const [methodError, setMethodError] = useState("");
  const [seat, setSeat] = useState("");
  const handleChangeSeat = (newValue) => {
    setSeat(newValue);
    setSeatError("");
  };
  const [seatError, setSeatError] = useState("");

  const [paymentOrPack, setPaymentOrPack] = useState("");
  const handleChangePaymentOrPack = (newValue) => {
    setPaymentOrPack(newValue);
  };
  const handleChangeType = (newValue) => {
    setType(newValue);
  };
  const [value, setValue] = useState("");
  const handleChangeValue = (newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    fetchData();
  }, [ts]);

  const [idPackageMembership, setIdPackageMembership] = useState("");

  useEffect(() => {
    axios
      .get(`/sessions/${sessionId}/pack?option=${type}&user_id=${user.value}`)
      .then((result) => {
        console.log("aa=", result.data.data);
        result?.data?.data?.length
          ? setOptionsPackagesMemberships(
              result.data.data.map((item, index) => {
                return {
                  label:
                    type === "package"
                      ? `${item.subpackage?.package?.name} (${item.subpackage?.name})`
                      : `${item.submembership?.membership?.name} (${item.submembership?.name})`,
                  value: String(item.id),
                };
              }),
            )
          : setOptionsPackagesMemberships([]);
      })
      .catch((err) => console.log(err));
  }, [user, type]);
  async function fetchData() {
    let responseUsers = "";
    let responseClass = "";
    let responsePackages = "";
    let responseMemberships = "";
    try {
      responseUsers = await axios.get(`/app/users?get_all=1`);
      setOptionsUsers(
        responseUsers.data.data.map((item, index) => {
          return {
            label:
              item.id +
              " " +
              item.first_name +
              " " +
              item.last_name +
              ` (Email: ${item.email})`,
            value: String(item.id),
          };
        }),
      );
    } catch (error) {
      console.log(error);
    }
    try {
      responseClass = await axios.get(`/classes/${classId}?per_page=1000`);
      responseClass.data.data.type === "spot" &&
        setSeats(
          responseClass.data.data.seats_available.map((item, index) => {
            return {
              label: item.label,
              value: String(item.id),
            };
          }),
        );
      setClassType(responseClass.data.data.type);
    } catch (error) {
      console.log(error);
    }

    setIsSaving(false);
    // try {
    //   responsePackages = await axios.get(`/packages?per_page=1000`);
    //   setOptionsPackages(
    //     responsePackages.data.data.data.map((item, index) => {
    //       return {
    //         label: item.name,
    //         value: String(item.id),
    //       };
    //     })
    //   );
    // } catch (error) {
    //   console.log(error);
    // }
    // try {
    //   responseMemberships = await axios.get(`/memberships?per_page=1000`);
    //   setOptionsMemberships(
    //     responseMemberships.data.data.data.map((item, index) => {
    //       return {
    //         label: item.name,
    //         value: String(item.id),
    //       };
    //     })
    //   );
    // } catch (error) {
    //   console.log(error);
    // }

    setIsSaving(false);
  }
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "Booking has been done successfully",
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [error, setError] = useState("");
  return (
    <Page
      narrowWidth
      backAction={{
        onAction: () =>
          navigate(`/admin/sessions/${sessionId}/classes/${classId}/bookings`),
      }}
      title="Book"
    >
      {isSaving ? <Loading /> : null}
      <Card>
        <FormLayout>
          <Text>User</Text>
          <Select2
            options={optionsUsers}
            onChange={handleChangeUser}
            value={user}
            placeholder="Please select"
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            menuPosition="absolute"
          />
          <InlineError message={userError}></InlineError>

          <Select
            label="Payment / Subscription"
            options={[
              { label: "Payment", value: "payment" },
              {
                label: "Subscription",
                value: "pack",
              },
            ]}
            onChange={handleChangePaymentOrPack}
            value={paymentOrPack}
            placeholder="Please select"
          />

          {paymentOrPack === "payment" ? (
            <>
              <Select
                label="Payment Method"
                options={[
                  { label: "Wallet", value: "wallet" },
                  {
                    label: "Offline Card",
                    value: "offline_card",
                  },
                  { label: "Cash ", value: "cash" },
                  { label: "Bank Transfer", value: "bank_transfer" },
                ]}
                onChange={handleChangeMethod}
                value={method}
                error={methodError}
                placeholder="Please select"
              />
              {method === "bank_transfer" && (
                <div style={{ marginTop: "10px" }}>
                  <TextField
                    label="Amount"
                    type="number"
                    value={bankTransferAmount}
                    onChange={handleChangeBankTransferAmount}
                    error={bankTransferAmountError}
                    placeholder="Enter amount"
                  />
                </div>
              )}
            </>
          ) : paymentOrPack === "pack" ? (
            <Select
              label="Package / Membership"
              options={[
                { label: "Package", value: "package" },
                {
                  label: "Membership",
                  value: "membership",
                },
              ]}
              onChange={handleChangeType}
              value={type}
              // error={methodError}
              placeholder="Please select"
            />
          ) : null}

          {type && paymentOrPack === "pack" && (
            <Select
              label="Select an option"
              options={optionsPackagesMemberships}
              onChange={handleChangeValue}
              value={value}
              // error={methodError}
              placeholder="Please select"
            />
          )}

          {classType === "spot" ? (
            <Select
              label="Seat"
              options={seats}
              onChange={handleChangeSeat}
              value={seat}
              error={seatError}
              placeholder="Please select"
            />
          ) : null}
          <InlineError message={error} />

          <div style={{ height: "250px" }}></div>
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );

  function handleSave() {
    if (
      user === "" ||
      (method === "" && paymentOrPack === "payment") ||
      (method === "bank_transfer" &&
        paymentOrPack === "payment" &&
        bankTransferAmount === "") ||
      (classType === "spot" && seat === "")
    ) {
      user === "" && setUserError("Please choose a user");
      method === "" &&
        paymentOrPack === "payment" &&
        setMethodError("Please choose a method");
      method === "bank_transfer" &&
        paymentOrPack === "payment" &&
        bankTransferAmount === "" &&
        setBankTransferAmountError("Please enter an amount");
      classType === "spot" &&
        seat === "" &&
        setSeatError("Please choose a seat");
    } else {
      setIsSaving(true);
      axios
        .post(`/classes/${classId}/sessions/${sessionId}/${classType}/book`, {
          user_id: user.value,
          ...(paymentOrPack === "payment" && { payment_method: method }),
          ...(paymentOrPack === "payment" &&
            method === "bank_transfer" && {
              bank_transfer_amount: bankTransferAmount,
            }),
          ...(classType === "spot" && { reserved_seat_id: seat }),
          ...(type === "package" &&
            paymentOrPack === "pack" && {
              package_booking_id: value,
            }),
          ...(type === "membership" &&
            paymentOrPack === "pack" && {
              membership_booking_id: value,
            }),
          is_free: paymentOrPack === "payment" ? false : true,
        })
        .then((result) => {
          setIsSaving(false);
          toggleActive();
        })
        .catch((error) => {
          setError(error.response.data.message);
          setIsSaving(false);
        });
    }
  }
};

export default BookPastUpcoming;
